module.exports = __webpack_public_path__ + "static/media/ppj.0b5e87d7.png";